import { usePathname, useSearchParams } from "next/navigation"
import { useEffect } from "react"
import { routeHistory } from "@/lib/route-history"

export function useRouteHistory() {
	const pathname = usePathname()
	const searchParams = useSearchParams()

	// 自动记录当前路由
	useEffect(() => {
		const params: Record<string, string> = {}
		searchParams.forEach((value, key) => {
			params[key] = value
		})

		routeHistory.push(
			pathname,
			Object.keys(params).length > 0 ? params : undefined,
		)
	}, [pathname, searchParams])

	return {
		/**
		 * 获取路由历史
		 */
		getHistory: () => routeHistory.getHistory(),

		/**
		 * 获取上一个路由
		 */
		getPrevious: () => routeHistory.getPrevious(),

		/**
		 * 检查是否从指定路径来的
		 */
		isFromPath: (path: string) => routeHistory.isFromPath(path),

		/**
		 * 检查是否从指定路径列表中的任一路径来的
		 */
		isFromPaths: (paths: string[]) => routeHistory.isFromPaths(paths),

		/**
		 * 检查是否从匹配模式的路径来的
		 */
		isFromPattern: (pattern: RegExp) => routeHistory.isFromPattern(pattern),

		/**
		 * 清空历史记录
		 */
		clear: () => routeHistory.clear(),

		/**
		 * 获取当前路由
		 */
		getCurrent: () => routeHistory.getCurrent(),

		/**
		 * 手动添加路由记录
		 */
		push: (path: string, params?: Record<string, string>) =>
			routeHistory.push(path, params),
	}
}
